var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 3C8.02944 3 4 7.02944 4 12H1L4.89 15.89L4.96 16.03L9 12H6C6 8.13401 9.13401 5 13 5C16.866 5 20 8.13401 20 12C20 15.866 16.866 19 13 19C11.067 19 9.31733 18.2143 8.05025 16.9497L6.635 18.365C8.26498 19.995 10.515 21 13 21C17.9706 21 22 16.9706 22 12C22 7.02944 17.9706 3 13 3ZM12 8V13L16.28 15.54L17 14.33L13.5 12.25V8H12Z",
    fill: "#1C1B1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.af1977ff35ed3f2384f7d83634417cae.svg";
export { ForwardRef as ReactComponent };